export default {
    methods: {
        getFormattedDocument(documentString) {
            if (documentString && typeof documentString == 'string') {
                if (documentString.length == 11)
                    return this.getFormatedCpf(documentString)
                else if (documentString.length == 14)
                    return this.getFormatedCnpj(documentString)
            }

            return ''
        },
        getFormatedCpf(documentString) {
            if (documentString && typeof documentString == 'string' && documentString.length == 11)
                return documentString.padStart(11, '0').replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')

            return ''
        },
        getFormatedCnpj(documentString) {
            if (documentString && typeof documentString == 'string' && documentString.length == 14)
                return documentString.padStart(14, '0').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')

            return ''
        },
        isCpfFormatted(documentFormatted) {
            if (documentFormatted && typeof documentFormatted == 'string')
                return documentFormatted.match(/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}\-[0-9]{2}$/g)

            return false
        },
        isCnpjFormatted(documentFormatted) {
            if (documentFormatted && typeof documentFormatted == 'string')
                return documentFormatted.match(/^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/[0-9]{4}\-[0-9]{2}$/g)

            return false
        },
    },
}
